import React, { useState } from "react";
import { AnimatePresence } from "framer-motion";
import {
  ResetPasswordDetailsOne,
  ResetPasswordDetailsTwo,
  ResetPasswordDetailsThree,
} from "../../components/auth/ResetPasswordDetails";
import { Box, Typography, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { ButtonContainedLight } from "../../components/UIElements/button";
import { PATH_AUTH } from "../../routes/path";
import { StatePageContainer } from "../../components/UIElements/pageUITransition";

const ResetPassword: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [pageNumber, setPageNumber] = useState<number>(1);
  const [values, setValues] = useState({
    email: "",
    code: "",
    password: "",
    token: "",
  });
  const handlePage = () => {
    setPageNumber((prev) => prev + 1);
  };
  const handlePrevPage = () => {
    if (pageNumber === 1) {
      return;
    }
    setPageNumber((prev) => prev - 1);
  };

  const handleBackClick = () => {
    if (pageNumber === 1) {
      navigate(PATH_AUTH.signIn);
    } else {
      handlePrevPage();
    }
  };
  return (
    <Box
      sx={{
        background: "white",
        paddingTop: 3,
      }}
    >
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        sx={{ margin: 3, gap: 4 }}
      >
        <Box>
          <ButtonContainedLight sx={undefined} onclick={handleBackClick}>
            Back
          </ButtonContainedLight>
        </Box>
        <AnimatePresence mode="wait">
          {pageNumber === 1 && (
            <StatePageContainer id="page1">
              <Box sx={{ width: "100%" }}>
                <Typography
                  color="primary"
                  variant="h2"
                  sx={{
                    fontWeight: 700,
                    fontFamily: "DM Sans",
                    letterSpacing: "-0.23999999463558197px",
                  }}
                >
                  Forgot Your Password?
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: theme.palette.text.primary }}
                >
                  Let’s help you recover <br /> it
                </Typography>
              </Box>
            </StatePageContainer>
          )}
          {pageNumber === 2 && (
            <StatePageContainer id="page2">
              <Box sx={{ width: "100%" }}>
                <Typography
                  color="primary"
                  variant="h2"
                  sx={{
                    fontWeight: 700,
                    fontFamily: "DM Sans",
                    letterSpacing: "-0.23999999463558197px",
                  }}
                >
                  Confirm Email
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: theme.palette.text.secondary }}
                >
                  A 4 digit OTP has been sent you <br />
                  <span style={{ fontWeight: 600 }}> {values?.email}</span>
                </Typography>
              </Box>
            </StatePageContainer>
          )}

          {pageNumber === 3 && (
            <StatePageContainer id="page3">
              <Box sx={{ width: "100%" }}>
                <Typography
                  color="primary"
                  variant="h2"
                  sx={{
                    fontWeight: 700,
                    fontFamily: "DM Sans",
                    letterSpacing: "-0.23999999463558197px",
                  }}
                >
                  Create New Password
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: theme.palette.text.secondary }}
                >
                  Enter a strong password, to secure your Account
                </Typography>
              </Box>
            </StatePageContainer>
          )}
        </AnimatePresence>
        <AnimatePresence mode="wait">
          {pageNumber === 1 && (
            <StatePageContainer id="page1">
              <ResetPasswordDetailsOne
                values={values}
                changeValues={setValues}
                pageHandler={handlePage}
                prevPage={handlePrevPage}
              />
            </StatePageContainer>
          )}
          {pageNumber === 2 && (
            <StatePageContainer id="page2">
              <ResetPasswordDetailsTwo
                values={values}
                changeValues={setValues}
                pageHandler={handlePage}
                prevPage={handlePrevPage}
              />
            </StatePageContainer>
          )}
          {pageNumber === 3 && (
            <StatePageContainer id="page3">
              <ResetPasswordDetailsThree
                values={values}
                changeValues={setValues}
                pageHandler={handlePage}
                prevPage={handlePrevPage}
              />
            </StatePageContainer>
          )}
        </AnimatePresence>
      </Stack>
    </Box>
  );
};

export default ResetPassword;
